<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      isBreak
      :data="filter"
      @search="seach"
      @changeTime="changeTime"
      @clear="clear"
    ></ux-searchOption>
    <ux-searchOption
      class="x-button-list"
      isBreak
      :layout="layout2"
      @upgrade="upgrade"
      @instructions="instructions"
      @checkAll="checkAll"
      @exportData="exportData"
      @download="download"
      @importOrder="importOrder"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import imeiInput from '../template/imeiInput';
import upgrade from './template/upgrade';
import instructions from './template/instructions';
import importOrder from './template/importOrder';
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          width: '120px',
          type: 'input',
          placeholder: this.$t('HT.upgrade.mctype'),
          key: 'inside_soft_model',
          hideBtn: true,
          filterable: true
        },
        {
          width: '120px',
          type: 'input',
          placeholder: this.$t('HT.deviceManage.version'),
          key: 'version',
          hideBtn: true,
          filterable: true
        },
        {
          type: 'date',
          daterange: true,
          placeholder: this.$t('HT.pleaseSelect'),
          event: 'changeTime'
        },
        {
          width: '220px',
          render: (h) => {
            return h(imeiInput, {
              props: {
                value: this.filter.imeis
              },
              on: {
                change: (val) => {
                  this.filter.imeis = val;
                }
              }
            });
          }
        },
        {
          type: 'button',
          text: this.$t('HT.search1'),
          show: true,
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.clear'),
          plain: true,
          show: true,
          event: 'clear'
        }
      ],
      layout2: [
        {
          type: 'button',
          text: this.$t('HT.deviceManage.upgrade'),
          show: true,
          size: 'small',
          event: 'upgrade'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.upgrade1'),
          show: true,
          size: 'small',
          event: 'upgrade'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.checkAll'),
          show: true,
          size: 'small',
          event: 'checkAll'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.instructions'),
          show: true,
          size: 'small',
          event: 'instructions'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.instructions1'),
          show: true,
          size: 'small',
          event: 'instructions'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.exportData'),
          show: true,
          size: 'small',
          event: 'exportData'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.download'),
          show: true,
          size: 'small',
          event: 'download'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.importOrder'),
          show: true,
          size: 'small',
          event: 'importOrder'
        }
      ],
      columns: [
        // 表头数据
        {
          type: 'selection'
        },
        {
          label: 'IMEI',
          prop: 'imei',
          tooltip: true
        },
        {
          label: this.$t('HT.deviceManage.version'),
          prop: 'version',
          tooltip: true
        },
        {
          label: this.$t('HT.upgrade.mctype'),
          prop: 'inside_soft_model',
          tooltip: true
        },
        {
          label: this.$t('HT.deviceManage.outDatasTime'),
          prop: 'out_datas_time',
          tooltip: true
        },
        {
          label: this.$t('HT.deviceManage.lastTime'),
          prop: 'last_time',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        inside_soft_model: '', // 机型
        version: '', // 软件版本号
        start_time: '', // 开始时间
        end_time: '', // 结束时间
        imeis: '', // imei号
        page: 1,
        size: 10
      },
      apiList: [], // api 列表
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      let postData = JSON.parse(JSON.stringify(params));
      postData.imeis = postData.imeis.split(/[(\r\n)\r\n]+/);
      postData.imeis.forEach((item, index) => {
        if (!item) {
          postData.imeis.splice(index, 1); //删除空项
        }
      });
      this.$api.ams.getList(postData).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 升级
     */
    upgrade() {
      const title = this.$t('HT.deviceManage.updateDevice');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(upgrade, {
            props: {}
          });
        },
        confirm: (val) => {
          console.log(val);
        }
      });
    },

    /**
     * 全选
     */
    checkAll() {
      console.log('55');
    },

    /**
     * 指令
     */
    instructions() {
      const title = this.$t('HT.deviceManage.instructionsSend');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(instructions, {
            props: {}
          });
        },
        confirm: (val) => {
          console.log(val);
        }
      });
    },

    exportData() {
      console.log('exportData');
    },

    download() {
      console.log('download');
    },

    importOrder() {
      const title = this.$t('HT.deviceManage.importOrderTitle');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(importOrder, {
            props: {}
          });
        },
        confirm: (val) => {
          console.log(val);
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 清除
     */
    clear() {
      this.filter.model = '';
      this.filter.identifi = '';
      this.filter.imei = '';
      this.getList(this.filter);
    },

    /**
     * 时间筛选
     * @param {Array} array 起始时间数组
     */
    changeTime(array) {
      this.filter.page = 1;
      this.filter.start_time = array[0] ? array[0].replace(/-/g, '/') + ' 00:00:00' : '';
      this.filter.end_time = array[1] ? array[1].replace(/-/g, '/') + ' 00:00:00' : '';
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
<style lang="scss"></style>
